import { API } from 'aws-amplify';
import {
  GET_FLIGHT_TEST_PLAN_SUCCESS,
  GET_SLOTS_FOR_LANDING_PAD
} from './actionTypes';
import { newNotification } from './uiActions';

export const getFlightTestPlansForCell = (cellId: number) => async dispatch => {
  API.get('api', `/flighttestplan/${cellId}`, {})
    .then(res => {
        dispatch({
          type: GET_FLIGHT_TEST_PLAN_SUCCESS,
          payload: res
        });
    })
    .catch(error => {
      dispatch(
        newNotification({
          variant: 'error',
          message: error.message
        })
      );
    });
};

export const addFlightTestPlan = testPlan => async dispatch => {
  API.post('api', `/flighttestplan`, { body: testPlan })
    .then(res => {
        // dispatch(getFlightTestPlansForCell(testPlan.testCellId));
        dispatch(
          newNotification({
            variant: 'success',
            message: 'Added new flight test'
          })
        );
    })
    .catch(error => {
      dispatch(
        newNotification({
          variant: 'error',
          message: error.message
        })
      );
    });
};

export const updateFlightTestPlan = (
  testPlan,
  newStatus: string
) => async dispatch => {
  if(testPlan.status !== "CANCELLED"){
    testPlan.status = newStatus
    API.put('api', `/flighttestplan`, {
      body:  testPlan
    })
      .then(res => {
          // dispatch(getFlightTestPlansForCell(testPlan.testCellId));
          dispatch(
            newNotification({
              variant: 'success',
              message: 'Cancelled flight test'
            })
          );
      })
      .catch(error => {
        dispatch(
          newNotification({
            variant: 'error',
            message: error.message
          })
        );
      });
  }
  else{
    dispatch(
      newNotification({
        variant: 'error',
        message: "Test plan already cancelled"
      })
    );
  }
};

export const getLandingPadSlotAvailability = (
  cellId: number,
  landingPadId: number
) => async dispatch => {
  API.get('api', `/slot/viewSlots/remaining/pad/${cellId}/${landingPadId}`, {})
    .then(res => {
        dispatch({
          type: GET_SLOTS_FOR_LANDING_PAD,
          payload: {
            landingPadId: landingPadId,
            availability: res
          }
        });
    })
    .catch(error => {
      dispatch(
        newNotification({
          variant: 'error',
          message: 'Error getting landing pad slot availability'
        })
      );
    });
};
